import { buildDataTableCols, type DataTableColumn } from '@/components/custom/erp/data-table-v2';
import { formatDate, formatMoney, formatRoundedNumber } from '@/lib/formatUtils';
import { buildInputTableCols } from '@/components/custom/erp/input-table-v2';

// Main table
export const getDataTableColumns = (handleViewClick: (row: BanHangRecord) => void): DataTableColumn[] =>
  buildDataTableCols<BanHangRecord>([
    {
      field: 'status',
      headerName: 'Trạng thái',
      width: 120,
      renderCell: params => {
        const status = params.row.status;
        switch (status) {
          case '0':
            return 'Chưa ghi sổ';
          case '3':
            return 'Chờ duyệt';
          case '5':
            return 'Đã ghi sổ';
          default:
            return 'Khác';
        }
      }
    },
    {
      field: 'so_ct',
      headerName: 'Số chứng từ',
      width: 135,
      renderCell: params => (
        <button
          onClick={e => {
            e.stopPropagation();
            handleViewClick(params.row);
          }}
          className='hover:text-blue-500 hover:underline'
        >
          {params.row.so_ct}
        </button>
      )
    },
    {
      field: 'ngay_ct',
      headerName: 'Ngày c/từ',
      width: 120,
      renderCell: params => formatDate(params.row.ngay_ct)
    },
    {
      field: 'ma_kh',
      headerName: 'Mã khách hàng',
      width: 150,
      renderCell: params => params.row.ma_kh_data?.customer_code
    },
    {
      field: 'ten_kh',
      headerName: 'Tên khách hàng',
      width: 200,
      renderCell: params => params.row.ma_kh_data?.customer_name
    },
    { field: 'dien_giai', headerName: 'Diễn giải', width: 250 },
    {
      field: 'tk_no',
      headerName: 'Tk nợ',
      width: 100,
      renderCell: params => params.row.tk_data?.code || params.row.tk || ''
    },
    {
      field: 't_tien_nt',
      headerName: 'Tổng tiền',
      width: 150,
      columnType: 'number',
      renderCell: params => formatRoundedNumber(params.row.t_tien_nt)
    },
    {
      field: 'ma_nt',
      headerName: 'Ngoại tệ',
      width: 100,
      renderCell: params => params.row.ma_nt_data?.ma_nt || params.row.ma_nt || 'VND'
    },
    {
      field: 'ma_ngv',
      headerName: 'Loại phiếu thu',
      width: 150,
      renderCell: params => {
        const maNgv = params.row.ma_ngv;
        switch (maNgv) {
          case '1':
            return 'Theo hóa đơn';
          case '2':
            return 'Theo khách hàng';
          default:
            return '';
        }
      }
    }
  ]);

export const getInputTableColumns = (_ma_ngv?: string): DataTableColumn[] =>
  buildInputTableCols<BanHangRecord>([
    {
      field: 'ma_kh_data',
      headerName: 'Mã khách hàng',
      width: 150,
      renderCell: params => params.row.ma_kh_data?.customer_code || params.row.ma_kh || ''
    },
    {
      field: 'ten_kh',
      headerName: 'Tên khách hàng',
      width: 200,
      renderCell: params => params.row.ma_kh_data?.customer_name || ''
    },
    {
      field: 'id_hd_data',
      headerName: 'Hóa đơn',
      width: 150,
      renderCell: params => params.row.id_hd_data?.so_ct || params.row.id_hd || ''
    },
    {
      field: 'ngay_hd',
      headerName: 'Ngày hóa đơn',
      width: 120,
      renderCell: params => formatDate(params.row.id_hd_data?.ngay_ct)
    },
    {
      field: 'tk_co_data',
      headerName: 'Tài khoản có',
      width: 150,
      renderCell: params => params.row.tk_co_data?.code || params.row.tk_co || ''
    },
    {
      field: 'ten_tk',
      headerName: 'Tên tài khoản',
      width: 200,
      renderCell: params => params.row.tk_co_data?.name || ''
    },
    {
      field: 'ngoai_te',
      headerName: 'Ngoại tệ',
      width: 120,
      renderCell: params => params.row.id_hd_data?.ngoai_te || 'VND'
    },
    {
      field: 'ty_gia_hd',
      headerName: 'Tỷ giá hđ',
      width: 120,
      renderCell: params => params.row.ty_gia_hd || '1'
    },
    {
      field: 'tien_nt',
      headerName: 'Tiền VND',
      width: 150,
      columnType: 'number',
      renderCell: params => formatMoney(params.row.tien_nt)
    },
    {
      field: 'dien_giai',
      headerName: 'Diễn giải',
      width: 200,
      renderCell: params => params.row.dien_giai || ''
    }
  ]);
